import { LoadingButton } from '@mui/lab';
import { Button, CircularProgress } from '@mui/material';

import Dialog from 'Lib/muiComponents/dialog/Dialog';

export default function ConfirmDialog({ children, fullWidth = false, confirmText = 'Confirm', isConfirming, title = 'Confirm', onConfirm, open, toggle }) {
    return (
        <Dialog
            fullWidth={fullWidth}
            open={open}
            title={title}
            toggle={toggle}
            onClose={toggle}
            maxWidth="xs"
            actions={() => (
                <>
                    <Button variant="outlined" color="success" onClick={toggle} sx={{ mr: 2 }}>
                        Cancel
                    </Button>
                    <LoadingButton
                        loading={isConfirming}
                        variant="contained"
                        color="success"
                        onClick={onConfirm}
                        sx={{ boxShadow: 'none' }}
                        loadingIndicator={<CircularProgress color="success" size={16} />}
                    >
                        {confirmText}
                    </LoadingButton>
                </>
            )}
        >
            {children}
        </Dialog>
    );
}
